import {Parser, Generator } from 'sparqljs';
import settings from './settings';

/** Для создания экземпляров NamedNode */
const N3 = require('n3');
const { DataFactory } = N3;
const { namedNode } = DataFactory;

const parser = new Parser();
const generator = new Generator();

const getDefaultCatalog = () => {
    if (window.Liferay){
        if (window.Liferay.ThemeDisplay.isSignedIn())
            return settings.catalog.signed;
    };
    return settings.catalog.public;
};
const getDefaultGraph = () => {
    //console.log("request.js getDefaultGraph", window.Liferay, window.Liferay?window.Liferay.ThemeDisplay.isSignedIn():false, settings.catalog.graph.signed);
    if (window.Liferay){
        if (window.Liferay.ThemeDisplay.isSignedIn())
            return settings.catalog.graph.signed;
    };
    return settings.catalog.graph.public;
};

let default_catalog = getDefaultCatalog();
let default_graph = getDefaultGraph();


/** Класс описывающий запрос на получение и обновление данных */
export class Request {
    constructor(sparql, graph = null){
        this._pattern = sparql;
        this._graph = graph;
        this._request = parser.parse(sparql);
    }

    get pattern () { return this._pattern;};
    set pattern (sparql) { 
        this._pattern = sparql; 
        this._request = parser.parse(sparql);
    };

    get graph () { return this._graph;};
    get sparql () { return generator.stringify(this._request);};

    get request () {return this._request;};
    set request (request) {this._request = request;};

    clone() {return new Request(generator.stringify(this._request), this._graph); };
    clear() {this._request = parser.parse(this._pattern);};
    cloneOriginal() {return new Request(this._pattern, this._graph); };
}
const requests = [];
const registerRequest = (request) => {
    requests.push(request);
    return request;
};
/** Запрос с переключением графа при клонировании. 
 * В sparql запросе первым условием в секции where должно быть задание iri графа */
class RequestFirstCatalogInWhere extends Request {
    cloneOriginal() {
        //console.log("request.js RequestFirstCatalogInWhere", this, settings.catalog.iri);
        const request = new RequestFirstCatalogInWhere(this._pattern, this._graph); 
        request._request.where[0].triples[0]["subject"].value = settings.catalog.iri;
        return request;
    };
}

/** Специальный запрос, который использует внешний сформированный SPARQL
 * Для использования сделать clone и задать вызвать setSparql()
 */
const simple_sparql = 'SELECT ?s ?p ?o WHERE { ?s ?p ?o } LIMIT 1';
class SPARQLText extends Request {
    constructor(sparql, graph = null)
    { 
        super(sparql, graph); 
        this._sparql = sparql;
    };
    get sparql () { return this._sparql;};
    setSparql (text) {this._sparql = text;};
    clone() {return new SPARQLText(simple_sparql, this._graph); };
    cloneOriginal() {return new SPARQLText(this._pattern, this._graph); };
}
export const AnySPARQLRequest = registerRequest(new SPARQLText(simple_sparql, default_graph));
/***************************************************************************************************/
//                  RRRRR       DDDDD       FFFFFF
//                  R    R      D    D      F
//                  R    R      D     D     F
//                  RRRRR       D     D     FFFF
//                  RR          D     D     F
//                  R  R        D    D      F 
//                  R   RR      DDDDD       F 
/***************************************************************************************************/

/** Получение списка всех предикат->объект  для субъекта */
class PredicatSubject extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(iri){
        this._request.where[0].triples[0]["subject"].value = iri;
        this._request.prefixes.URI = iri;
    }
};
const predicatSubject_sparql = 'PREFIX IRI: <http://localhost/sksa> '+
' select DISTINCT ?predicat ?object '+
' where { IRI: ?predicat ?object } ';
export const PredicatSubjectRequest = registerRequest(new PredicatSubject(predicatSubject_sparql, default_graph));

/** Получение с указанием субъекта  */
const predicatSubject2_sparql = 'SELECT ?s ?p ?o WHERE { VALUES ?s { <http://localhost/sksa>} ?s ?p ?o. }';
class PredicatSubject2Class extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(iri){
        this._request.where[0].values[0]["?s"].value = iri;        
    }
};
export const PredicatSubject2Request = registerRequest(new PredicatSubject2Class(predicatSubject2_sparql, default_graph));

/** Построение текста запроса для рекурсивного получения данных в анонимных узлах */
export const buildSubjectBlank_sparql = (subjectIRI, predicateIRIs) => `SELECT DISTINCT ?s ?p ?o
WHERE {
    {
        VALUES ?s { <${subjectIRI}> }
        VALUES ?p { ${predicateIRIs.map((uri) => `<${uri}>`).join("\n  ")} }
        ?s ?p ?o .
    }
    UNION
    {
        VALUES ?root { <${subjectIRI}> }
        VALUES ?rootPredicate { ${predicateIRIs.map((uri) => `<${uri}>`).join("\n    ")} }
        ?root ?rootPredicate ?start .
        FILTER(isBlank(?start))
       ?start ?px ?s
        OPTION ( TRANSITIVE, T_IN(?start), T_OUT(?s), T_DISTINCT, T_MIN(0) )
        FILTER(isBlank(?s))
        ?s ?p ?o .
    }
}
ORDER BY ?s ?p ?o`;

/** Получение количество триплетов, для которых subject равен параметру */
class CountSubject extends Request{
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(iri){
        this._request.variables[0].expression.expression.value = iri;
        this._request.where[0].triples[0]["subject"].value = iri;
        this._request.prefixes.IRI = iri;
    }
};
const countSubject_sparql = 'PREFIX IRI: <http://www.w3.org/2004/02/skos/core#inScheme> '+
' select (COUNT( IRI: ) AS ?count) '+
' where { IRI: ?pr ?ob }';
export const CountSubjectRequest = registerRequest(new CountSubject(countSubject_sparql, default_graph));

/** Удаление всех триплетов, для которых subject равен параметру */
class DeleteSubject extends Request{
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["subject"].value = IRI;
        this._request.updates[0].where[0].triples[0]["subject"].value = IRI;
        this._request.prefixes.DEL_IRI = IRI;
    }
}
const deleteSubject_sparql = 'PREFIX DEL_IRI: <http://www.w3.org/2004/02/skos/core#inScheme> '+
' DELETE { DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { DEL_IRI: ?prop ?val }';
export const DeleteSubjectRequest = registerRequest(new DeleteSubject(deleteSubject_sparql, default_graph));

/** Удаление всех триплетов, для которых object равен параметру */
class DeleteObject extends Request{
    constructor(sparql, graph = null){ super(sparql, graph); }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].value = IRI;
        this._request.updates[0].where[0].triples[0]["object"].value = IRI;
        this._request.prefixes.DEL_IRI = IRI;
    }
}
const deleteObject_sparql = 'PREFIX DEL_IRI: <http://www.w3.org/2004/02/skos/core#inScheme> '+
' DELETE { ?s ?p DEL_IRI: } '+
' INSERT {} '+
' WHERE { ?s ?p DEL_IRI: }';
export const DeleteObjectRequest = registerRequest(new DeleteObject(deleteObject_sparql, default_graph));

/** Получение информации метке (label) по URI субъекта */
class RdfsLabel extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setURI(uri){
        this._request.where[0].triples[0]["subject"].value = uri;
        this._request.prefixes.URI_PROP = uri;
    }
};
const rdfsLabel_sparql = 'PREFIX URI_PROP: <http://www.w3.org/2004/02/skos/core#inScheme>'+
' select DISTINCT ?label '+
' where {   URI_PROP: <http://www.w3.org/2000/01/rdf-schema#label> ?label }' ;
export const RdfsLabelRequest = registerRequest(
    new RdfsLabel(rdfsLabel_sparql, default_graph)
);

const dcTermsTitle_sparql = 'PREFIX URI_PROP: <http://www.w3.org/2004/02/skos/core#inScheme>'+
' select DISTINCT ?label '+
' where {   URI_PROP: <http://purl.org/dc/terms/title> ?label }' ;
export const DcTermsTitleRequest = registerRequest(
    new RdfsLabel(dcTermsTitle_sparql, default_graph)
);


/** Получить информацию об описании (description) по IRI субъекта http://purl.org/dc/terms/description  */
class DCTermsDescription extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setURI(uri){
        this._request.where[0].triples[0]["subject"].value = uri;
        this._request.prefixes.URI_PROP = uri;
    }
};
const dctermsDescription_sparql = 'PREFIX URI_PROP: <http://www.w3.org/ns/adms#Asset>'+
' select DISTINCT ?description '+
' where {   URI_PROP: <http://purl.org/dc/terms/description> ?description }' ;
export const DCTermsDescriptionRequest = registerRequest(
    new DCTermsDescription(dctermsDescription_sparql, default_graph)
);


/** Получение набора триплетов заданных iri.  */
const triplesDetails_sparql = 'select ?predicat ?object '+
'where { <http://localhost/iri> ?predicat ?object .'+
'  FILTER (?predicat IN (<http://www.w3.org/1999/02/22-rdf-syntax-ns#type>))}' ;

class PredicatSubjectFilter extends PredicatSubject {
    
    constructor(sparql, graph = null){ super(sparql, graph); };
    
    setParams(iri, predicates=[]){
        this.clear();
        this._request.where[0].triples[0]["subject"].value = iri;
        this._request.where[1].expression.args[1] = predicates.map(predicate => namedNode(predicate));
    };
};

export const PredicatSubjectFilterRequest = registerRequest(
    new PredicatSubjectFilter(triplesDetails_sparql, default_graph)
);

/** Список типов у субъекта */
const rdfTypes_sparql = 'PREFIX IRI: <http://localhost/sksa> '+
'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
' SELECT DISTINCT ?type '+
' WHERE { IRI: rdf:type ?type .} '+
' ORDER BY ?type ';

class RdfTypesClass extends PredicatSubject {
        constructor(sparql, graph = null){ super(sparql, graph); };
};

export const RdfTypesRequest = registerRequest(
    new RdfTypesClass(rdfTypes_sparql, default_graph)
);

/***************************************************************************************************/
//                  DDDDD        CCCC        AAAA       TTTTTTT
//                  D    D      C    C      A    A         T
//                  D     D     C           A    A         T
//                  D     D     C           A    A         T
//                  D     D     C           AAAAAA         T
//                  D    D      C    C      A    A         T
//                  DDDDD        CCCC       A    A         T
/***************************************************************************************************/
/** Запросы для получения данные в Virtuoso */
const admsAssets_graph  = default_graph;

/** Получение детальной информации о каталоге */
const dcatCatalogDetails_sparql = 'select ?predicat ?object '+
'where { <'+default_catalog+'> ?predicat ?object}';
const dcatCatalogDetails = registerRequest(new Request(dcatCatalogDetails_sparql, admsAssets_graph));
export const DcatCatalogDetailsRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        dcatCatalogDetails._request.where[0].triples[0]["subject"].value = catalogIRI;
    return dcatCatalogDetails;
}


/** Получение списка доступных активов */
const admsAssets_sparql = 'SELECT DISTINCT ?IRI ?dsn ?dsv ?dcp '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI.'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER((LANG(?dcp)) = "ru") } .'+
'  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn)'+
'} order by ?dsn';
const admsAssets = registerRequest(new RequestFirstCatalogInWhere(admsAssets_sparql, admsAssets_graph));
export const AdmsAssetsRequest = (catalogIRI = settings.catalog.iri, lang=settings.catalog.lang) => {
    if (catalogIRI)
        admsAssets._request.where[0].triples[0]["subject"].value = catalogIRI;
    if (lang){
        admsAssets._request.where[2].patterns[1].expression.args[1].value=lang;
        admsAssets._request.where[4].patterns[1].expression.args[1].value=lang;
    };
    return admsAssets;
}

/** Получение количества доступных активов */
const admsAssetsCount_sparql = 'select (COUNT(distinct ?IRI) AS ?count) '+
'where { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI .}' ;//+
export const AdmsAssetsCount = registerRequest(new RequestFirstCatalogInWhere(admsAssetsCount_sparql, admsAssets_graph));
export const AdmsAssetsCountRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        AdmsAssetsCount._request.where[0].triples[0]["subject"].value = catalogIRI;
    return AdmsAssetsCount;
}

/** Получение списка классификационных схем, связанных с каталогом актива */
const admsThemeTaxonomy_sparql = 'select ?IRI '+
'where { <'+default_catalog+'> <http://www.w3.org/ns/dcat#themeTaxonomy> ?IRI}';
const admsThemeTaxonomy = registerRequest(new Request(admsThemeTaxonomy_sparql, admsAssets_graph));
export const AdmsThemeTaxonomyRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        admsThemeTaxonomy._request.where[0].triples[0]["subject"].value = catalogIRI;
    return admsThemeTaxonomy;
}


/** Добавление нового элемента в каталог */
class NewAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(catalog, IRI, type, label, lang){
        const value = '"'+label+'"'+((lang)?"@"+lang:"");
        //console.log("NewAssetInCatalog.setValues", catalog, IRI, label, lang, value);
        this._request.updates[0].insert[0].triples[0]["subject"].value = catalog;
        this._request.updates[0].insert[0].triples[0]["object"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[2]["object"].value = type;
        this._request.updates[0].insert[0].triples[2]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[2]["object"].value = value;
        this._request.prefixes.IRI = IRI;
    }
};
export const admsNewAsset_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/dcat#Dataset> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Asset Name" }'+
' WHERE {}'
export const NewAssetInCatalogRequest = registerRequest(new NewAssetInCatalog(admsNewAsset_sparql, admsAssets_graph));

/** Удаление элемента из каралога, с удалением всех триплетов имеющих subject iri элемента */
class DeleteAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setCatalog(catalog){
        this._request.updates[0].delete[0].triples[0]["subject"].id = catalog;
        this._request.updates[0].where[0].triples[0]["subject"].id = catalog;
    }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].id = IRI;
        this._request.updates[0].delete[0].triples[1]["subject"].id = IRI;
        this._request.updates[0].where[0].triples[0]["object"].id = IRI;
        this._request.updates[0].where[0].triples[1]["subject"].id = IRI;
        this._request.prefixes.DEL_IRI = IRI;
    }
};
export const admsDeleteAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> DEL_IRI: . '+
' DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> DEL_IRI: . '+
' DEL_IRI: ?prop ?val . }';
export const DeleteAssetInCatalogRequest = registerRequest(new DeleteAssetInCatalog(admsDeleteAsset_sparql, admsAssets_graph));

/** Исключение линка ассета в каталоге  */
class UnlinkAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setCatalog(catalog){
        this._request.updates[0].delete[0].triples[0]["subject"].value = catalog;
        this._request.updates[0].where[0].triples[0]["subject"].value = catalog;
    }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].value = IRI;
        this._request.updates[0].where[0].triples[0]["object"].value = IRI;
        this._request.prefixes.IRI = IRI;
    }
};
export const admsUnlinkAsset_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: } '+
' INSERT {} '+
' WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: } ';
export const UnlinkAssetInCatalogRequest = registerRequest(new UnlinkAssetInCatalog(admsUnlinkAsset_sparql, admsAssets_graph));

/** Установка новой связи с элементом в каталоге */
class LinkAssetInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValue(catalog, asset){
        this._request.updates[0].insert[0].triples[0]["subject"].value = catalog;
        this._request.updates[0].insert[0].triples[0]["object"].value = asset;
        this._request.prefixes.IRI = IRI;
    }
};
export const admsLinkAsset_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> IRI: } '+
' WHERE {}'
export const LinkAssetInCatalogRequest = registerRequest(new LinkAssetInCatalog(admsLinkAsset_sparql, admsAssets_graph));


/** Получение списка активов не связанных с каталогом */
const admsUnLinkAssets_sparql = 'SELECT ?IRI ?dsn ?dsv '+
'WHERE { ?TYPE <http://www.w3.org/2000/01/rdf-schema#subClassOf> <http://www.w3.org/ns/dcat#Resource> .'+
'  ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?TYPE '+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
'  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn)'+
'  MINUS { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI} '+
'} order by ?dsn';
const AdmsUnLinkAssets = registerRequest(new RequestFirstCatalogInWhere(admsUnLinkAssets_sparql, admsAssets_graph));
export const AdmsUnLinkAssetsRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        AdmsUnLinkAssets._request.where[5].patterns[0].triples[0]["subject"].value = catalogIRI;
    return AdmsUnLinkAssets;
}

/** Получение количества доступных активов */
const admsUnLinkAssetsCount_sparql = 'select (COUNT(distinct ?IRI) AS ?count) '+
'where { ?TYPE <http://www.w3.org/2000/01/rdf-schema#subClassOf> <http://www.w3.org/ns/dcat#Resource> . ' +
'  ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?TYPE '+
'  MINUS { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI} '+
' }';
const AdmsUnLinkAssetsCount = registerRequest(new RequestFirstCatalogInWhere(admsUnLinkAssetsCount_sparql, admsAssets_graph));
export const AdmsUnLinkAssetsCountRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        AdmsUnLinkAssetsCount._request.where[1].patterns[0].triples[0]["subject"].value = catalogIRI;
    return AdmsUnLinkAssetsCount;
}

/** Получение краткой информации об активе (наименования, описания и версии актива) */
class AdmsAssetBrifInfo_сlass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setAsset(iri){
        this._request.variables[0].expression.value = iri;
        //this._request.where[0].triples[0]["object"].value = iri;
        this._request.where[0].patterns[0].triples[0]["subject"].value = iri;
        this._request.where[1].patterns[0].triples[0]["subject"].value = iri;
        this._request.where[2].patterns[0].triples[0]["subject"].value = iri;
        this._request.where[3].patterns[0].triples[0]["subject"].value = iri;
    }
};
const admsAssetBrifInfo_sparql = 'SELECT (<http://www.w3.org/ns/dcat#MyResource> as ?IRI) ?dsn ?dsv ?dcp '+
//'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> <http://www.w3.org/ns/dcat#MyResource>.'+
'  WHERE { OPTIONAL { <http://www.w3.org/ns/dcat#MyResource> <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
'  OPTIONAL { <http://www.w3.org/ns/dcat#MyResource> <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
'  OPTIONAL { <http://www.w3.org/ns/dcat#MyResource> <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
'  OPTIONAL { <http://www.w3.org/ns/dcat#MyResource> <http://purl.org/dc/terms/description> ?dcp FILTER((LANG(?dcp)) = "ru") } .'+
'  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn)'+
'} order by ?dsn';
const AdmsAssetBrifInfo = registerRequest(new AdmsAssetBrifInfo_сlass(admsAssetBrifInfo_sparql, admsAssets_graph));
export const AdmsAssetBrifInfoRequest = (catalogIRI = settings.catalog.iri) => {    
    // if (catalogIRI)
    //     AdmsAssetBrifInfo._request.where[0].triples[0]["subject"].value = catalogIRI;
    return AdmsAssetBrifInfo;
}

/** Получение первых букв в названиях и их количествоа */
const rdfsLabelFirstCharCount_sparql='SELECT (SUBSTR(?dsn, 1, 1) as ?firstlitera) (count(?IRI) as ?cnt) '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI. '+
'  ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn } '+
// '  ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn. '+
// '  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv. } '+
// '  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp. '+
// '    FILTER((LANG(?dcp)) = "ru"^^<http://www.w3.org/2001/XMLSchema#string>) }} '+
' group by ?dsn '+
' order by ?firstlitera';
const RdfsLabelFirstCharCount = registerRequest(
    new RequestFirstCatalogInWhere(rdfsLabelFirstCharCount_sparql, admsAssets_graph)
);
export const RdfsLabelFirstCharCountRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        RdfsLabelFirstCharCount._request.where[0].triples[0]["subject"].value = catalogIRI;
    return RdfsLabelFirstCharCount;
}

/** Удаление элемента из Asset, с удалением всех триплетов имеющих subject iri элемента */
class DeleteElementInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setAsset(asset){
        this._request.updates[0].delete[0].triples[0]["subject"].value = asset;
        this._request.updates[0].where[0].triples[0]["subject"].value = asset;
    }
    setIRI(IRI){
        this._request.updates[0].delete[0].triples[0]["object"].value = IRI;
        this._request.updates[0].delete[0].triples[1]["subject"].value = IRI;
        this._request.updates[0].where[0].triples[0]["object"].value = IRI;
        this._request.updates[0].where[0].triples[1]["subject"].value = IRI;
        this._request.prefixes.DEL_IRI = IRI;
    }
};
export const admsDeleteWikiInAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <http://hbz.ru/adms/asset> <http://purl.semanticpro.org/ontologies/sksa/wiki> DEL_IRI: . '+
' DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { <http://hbz.ru/adms/asset> <http://purl.semanticpro.org/ontologies/sksa/wiki> DEL_IRI: . '+
' DEL_IRI: ?prop ?val . }';
export const DeleteWikiInAssetRequest = registerRequest(
    new DeleteElementInAsset(admsDeleteWikiInAsset_sparql, admsAssets_graph)
);

export const admsDeleteDistributionInAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
' DELETE { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> DEL_IRI: . '+
' DEL_IRI: ?prop ?val } '+
' INSERT {} '+
' WHERE { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> DEL_IRI: . '+
' DEL_IRI: ?prop ?val . }';
export const DeleteDistributionInAssetRequest = registerRequest(
    new DeleteElementInAsset(admsDeleteDistributionInAsset_sparql, admsAssets_graph)
);


/** Добавление нового элемента в Asset (простая версия). Добавляет только dcterms:title */
class NewElementInAssetSimple extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setAsset(asset){
        this._request.updates[0].insert[0].triples[0]["subject"].value = asset;
    }
    setValues(IRI, label, lang){
        this._request.updates[0].insert[0].triples[0]["object"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[2]["subject"].value = IRI;
        this._request.prefixes.IRI = IRI;
        this._request.updates[0].insert[0].triples[2]["object"].value = label;
        this._request.updates[0].insert[0].triples[2]["object"].language = (lang)?lang:"";
        
    }
};

/** Добавление нового элемента в Asset */
class NewElementInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setAsset(asset){
        this._request.updates[0].insert[0].triples[0]["subject"].value = asset;
    }
    setValues(IRI, label, description, URL, lang){
        this._request.updates[0].insert[0].triples[0]["object"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[2]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[3]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[4]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[5]["subject"].value = IRI;
        this._request.prefixes.IRI = IRI;
        //const value = '"'+label+'"'+((lang)?"@"+lang:"");
        this._request.updates[0].insert[0].triples[2]["object"].value = label;
        this._request.updates[0].insert[0].triples[2]["object"].language = (lang)?lang:"";
        this._request.updates[0].insert[0].triples[3]["object"].value = label;
        this._request.updates[0].insert[0].triples[3]["object"].language = (lang)?lang:"";
        //const value2 = '"'+description+'"'+((lang)?"@"+lang:"");
        this._request.updates[0].insert[0].triples[4]["object"].value = description;
        this._request.updates[0].insert[0].triples[4]["object"].language = (lang)?lang:"";
        this._request.updates[0].insert[0].triples[5]["object"].value = URL;        
    }
};
export const admsNewWiki_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <http://purl.semanticpro.org/adms/asset> <http://purl.semanticpro.org/ontologies/sksa/wiki> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://purl.semanticpro.org/ontologies/sksa/Wiki> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Wiki Name" . '+
' IRI: <http://purl.org/dc/terms/title> "Wiki Name" . '+
' IRI: <http://purl.org/dc/terms/description> "Wiki Description" . '+
' IRI: <http://purl.semanticpro.org/ontologies/sksa/wiki> <http://purl.semanticpro.org/wiki> } '+
' WHERE {}'
export const NewWikiInAssetRequest = registerRequest(
    new NewElementInAsset(admsNewWiki_sparql, admsAssets_graph)
);

export const admsNewWikiSimple_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <http://purl.semanticpro.org/adms/asset> <http://purl.semanticpro.org/ontologies/sksa/wiki> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://purl.semanticpro.org/ontologies/sksa/Wiki> . '+
' IRI: <http://purl.org/dc/terms/title> "Wiki Name" } '+
' WHERE {}'
export const NewWikiInAssetSimpleRequest = registerRequest(
    new NewElementInAssetSimple(admsNewWikiSimple_sparql, admsAssets_graph)
);

export const admsNewDistribution_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/adms#AssetDistribution> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Distribution Name" . '+
' IRI: <http://purl.org/dc/terms/title> "Distribution Name" . '+
' IRI: <http://purl.org/dc/terms/description> "Distribution Description" . '+
' IRI: <http://www.w3.org/ns/dcat#downloadURL> "http://www.w3.org/ns/dcat#downloadURL" } '+
' WHERE {}'
export const NewDistributionInAssetRequest = registerRequest(
    new NewElementInAsset(admsNewDistribution_sparql, admsAssets_graph)
);

export const admsNewDistributionSimple_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { <http://hbz.ru/adms/asset> <http://www.w3.org/ns/dcat#distribution> IRI: . '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/dcat#Distribution> . '+
' IRI: <http://purl.org/dc/terms/title> "Distribution Name" } '+
' WHERE {}'
export const NewDistributionInAssetSimpleRequest = registerRequest(
    new NewElementInAssetSimple(admsNewDistributionSimple_sparql, admsAssets_graph)
);

/** Добавление нового элемента в каталог без привязки к активу */
class NewElementInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, label, lang){
        this._request.updates[0].insert[0].triples[0]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].value = IRI;
        this._request.prefixes.IRI = IRI;
        //const value = '"'+label+'"'+((lang)?"@"+lang:"");
        this._request.updates[0].insert[0].triples[1]["object"].value = label;
        this._request.updates[0].insert[0].triples[1]["object"].language = (lang)?lang:"";
    }

    /** Установить ТИП */
    setType(IRI){
        this._request.updates[0].insert[0].triples[0]["object"].value = IRI;
    }
};
export const skosNewConceptSchemeSimple_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#ConceptScheme> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Concept Scheme Name" } '+
' WHERE {}'
export const SkosNewConceptSchemeSimpleRequest = registerRequest(
    new NewElementInCatalog(skosNewConceptSchemeSimple_sparql, admsAssets_graph)
);

export const newElementSimple_sparql = 
'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2002/07/owl#NamedIndividual> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Concept Scheme Name" } '+
' WHERE {}'
export const NewElementInCatalogRequest = registerRequest(
    new NewElementInCatalog(newElementSimple_sparql, admsAssets_graph)
);

/** Запрос для получения содержимого ЕМД */
const contentEMD_sparql = 'SELECT ?s ?p ?o WHERE { ?s ?p ?o }';
class ContentEMD extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setGraph(newGraph) {this._graph = newGraph;};
};
export const ContentEMDRequest = registerRequest(
    new ContentEMD(contentEMD_sparql, default_graph)
);

/** Запрос для получения содержимого ЕМД */
const contentIEP_sparql = 'SELECT ?s ?p ?o WHERE { ?s ?p ?o }';
class ContentIEP extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setGraph(newGraph) {this._graph = newGraph;};
};
export const ContentIEPRequest = registerRequest(
    new ContentIEP(contentIEP_sparql, default_graph)
);

/** Добавление нового свойства  в Asset */
const addLiteral_sparql = ' DELETE {} '+
' INSERT { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> "" }'+
' WHERE {}'

export const addLiteralLang_sparql = ' DELETE {} '+
' INSERT { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> ""@ru }'+
' WHERE {}'

/** Добавление нового свойства, содержащего URI в Asset */
export const admsAddUriInAssetProperty_sparql = ' DELETE {} '+
' INSERT { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> <http://csi.semanticpro.org/object> }'+
' WHERE {}'

class AddPropertyInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, prefix, lang){
        this._request.updates[0].insert[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[0]["predicate"].id = prefix;
    }
};

export const AddPropertyInAssetRequest = registerRequest(
    new AddPropertyInAsset(addLiteral_sparql, admsAssets_graph)
);

/** Добавление нового триплета  */
class InsertTriple extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(subject, prefix, value, lang=undefined){
        this._request.updates[0].insert[0].triples[0]["subject"].value = subject;
        this._request.updates[0].insert[0].triples[0]["predicate"].value = prefix;
        //Убираем проверку на наличии " Относим её на уровень выше (который формирует данные)
        this._request.updates[0].insert[0].triples[0]["object"].value = value;
        this._request.updates[0].insert[0].triples[0]["object"].language = (lang)?lang:"";
    };
    setAnnotationValue(subject, prefix, value, lang=undefined){
        this._request.updates[0].insert[0].triples[0]["subject"].value = subject;
        this._request.updates[0].insert[0].triples[0]["predicate"].value = prefix;
        if (value.startsWith("http") && lang == undefined)
            this._request.updates[0].insert[0].triples[0]["object"].value = value;
        else{
            const firstQuotationMark = value.startsWith("\"");
            const endQuotationMark = value.endsWith("\"");
            this._request.updates[0].insert[0].triples[0]["object"].value = ((firstQuotationMark)?"":"\"")+value+((endQuotationMark)?"":"\"");
            this._request.updates[0].insert[0].triples[0]["object"].language = (lang)?lang:"";
        };
    };
    setObjectValue(subject, prefix, value){
        this._request.updates[0].insert[0].triples[0]["subject"].value = subject;
        this._request.updates[0].insert[0].triples[0]["predicate"].value = prefix;
        if (value.startsWith("http"))
            this._request.updates[0].insert[0].triples[0]["object"].value = value;
        else{
            this._request.updates[0].insert[0].triples[0]["object"].value = "\""+value+"\"";
        };
    };
    setDataValue(subject, prefix, value){
        this._request.updates[0].insert[0].triples[0]["subject"].value = subject;
        this._request.updates[0].insert[0].triples[0]["predicate"].value = prefix;
        this._request.updates[0].insert[0].triples[0]["object"].value = value;
    };
};
export const InsertTripleUriRequest = registerRequest(
    new InsertTriple(admsAddUriInAssetProperty_sparql, admsAssets_graph)
);
export const InsertTripleLiteralRequest = registerRequest(
    new InsertTriple(addLiteral_sparql, admsAssets_graph)
);
export const InsertTripleLiteralLangRequest = registerRequest(
    new InsertTriple(addLiteralLang_sparql, admsAssets_graph)
);

/**
 * Удаление предиката у субъекта
 */
const deletePredicate_sparql = 
' DELETE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> ?object }'+
' INSERT {} '+
' WHERE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> ?object }';
class DeletePredicate extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(subject, predicate){
        this._request.updates[0].delete[0].triples[0]["subject"].value = subject;
        this._request.updates[0].delete[0].triples[0]["predicate"].value = predicate;
        this._request.updates[0].where[0].triples[0]["subject"].value = subject;
        this._request.updates[0].where[0].triples[0]["predicate"].value = predicate;
    }
};
export const DeletePredicateRequest = registerRequest(
    new DeletePredicate(deletePredicate_sparql, admsAssets_graph)
);
/**
 * Удаление триплета с объектов ввиде URI
 */
 const deleteTripleUri_sparql = 
 ' DELETE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> <http://csi.semanticpro.org/object> }'+
 ' INSERT {} '+
 ' WHERE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> <http://csi.semanticpro.org/object> }';
 
class DeleteTripleUri extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(subject, predicate, object ){
        this._request.updates[0].delete[0].triples[0]["subject"].value = subject;
        this._request.updates[0].delete[0].triples[0]["predicate"].value = predicate;
        this._request.updates[0].delete[0].triples[0]["object"].value = object;
        this._request.updates[0].where[0].triples[0]["subject"].value = subject;
        this._request.updates[0].where[0].triples[0]["predicate"].value = predicate;
        this._request.updates[0].where[0].triples[0]["object"].value = object;
    }
};
export const DeleteTripleUriRequest = registerRequest(
    new DeleteTripleUri(deleteTripleUri_sparql, admsAssets_graph)
);
/**
 * Удаление триплета с объектом ввиде литерала без языка
 */
 const deleteTripleLiteral_sparql = 
 ' DELETE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> "object" }'+
 ' INSERT {} '+
 ' WHERE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> "object" }';
 export const DeleteTripleLiteralRequest = registerRequest(
    new DeleteTripleUri(deleteTripleLiteral_sparql, admsAssets_graph)
);

 /**
 * Удаление триплета с объектом ввиде литерала c языком
 */
const deleteTripleLiteralLang_sparql = 
' DELETE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> "object"@ru }'+
' INSERT {} '+
' WHERE { <http://csi.semanticpro.org/subject> <http://csi.semanticpro.org/predicat> "object"@ru }';

class DeleteTripleLiteral extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(subject, predicate, object, lang){
        this._request.updates[0].delete[0].triples[0]["subject"].value = subject;
        this._request.updates[0].delete[0].triples[0]["predicate"].value = predicate;
        this._request.updates[0].delete[0].triples[0]["object"].value = object;
        this._request.updates[0].delete[0].triples[0]["object"].language = (lang)?lang:"";
        this._request.updates[0].where[0].triples[0]["subject"].value = subject;
        this._request.updates[0].where[0].triples[0]["predicate"].value = predicate;
        this._request.updates[0].where[0].triples[0]["object"].value = object;
        this._request.updates[0].where[0].triples[0]["object"].language = (lang)?lang:"";
    }
};
export const DeleteTripleLiteralLangRequest = registerRequest(
    new DeleteTripleLiteral(deleteTripleLiteralLang_sparql, admsAssets_graph)
);
 
/**
 * Удаление свойства 
 */
 const removePropertyInAsset_sparql = 'PREFIX DEL_IRI: <http://purl.org/dc/terms/n3> '+
 ' DELETE { <http://csi.semanticpro.org/temp> DEL_IRI: ?val } '+
 ' INSERT {} '+
 ' WHERE { <http://csi.semanticpro.org/temp> DEL_IRI: ?val . }';
 
class RemovePropertyInAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, prefix ){
        this._request.prefixes.DEL_IRI = prefix;
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = prefix;
        this._request.updates[0].where[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].where[0].triples[0]["predicate"].id = prefix;
    }
};

export const RemovePropertyInAssetRequest = registerRequest(
    new RemovePropertyInAsset(removePropertyInAsset_sparql, admsAssets_graph)
);

/**
 * Обновление литерального свойства без учёта языка 
 */
 const updateLiteralSimpleProperty_sparql = 
 ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> "" } '+
 ' INSERT { <http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> "" }'+
 ' WHERE {}';
 class UpdateLiteralSimpleProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(subject, predicat, oldValue, newValue){
        this._request.updates[0].delete[0].triples[0]["subject"].value = subject;
        this._request.updates[0].delete[0].triples[0]["predicate"].value = predicat;
        this._request.updates[0].delete[0].triples[0]["object"].value = oldValue;
        this._request.updates[0].insert[0].triples[0]["subject"].value = subject;
        this._request.updates[0].insert[0].triples[0]["predicate"].value = predicat;
        this._request.updates[0].insert[0].triples[0]["object"].value = newValue;
    }
};

export const UpdateLiteralSimplePropertyRequest = registerRequest(
    new UpdateLiteralSimpleProperty(updateLiteralSimpleProperty_sparql,admsAssets_graph)
);

/**
 * Обновление литерального свойства с учётом языка
 */
 const updateLiteralProperty_sparql = 
 ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> ""@ru } '+
 ' INSERT { <http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> ""@ru }'+
 ' WHERE {}';

 class UpdateLiteralProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, predicat, oldValue, newValue, lang ){
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].delete[0].triples[0]["object"].id = "\""+oldValue+"\""+"@"+lang;
        this._request.updates[0].insert[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].insert[0].triples[0]["object"].id = "\""+newValue+"\""+"@"+lang;;
    }
};

export const UpdateLiteralPropertyRequest = registerRequest(
    new UpdateLiteralProperty(updateLiteralProperty_sparql, admsAssets_graph)
);


/**
 * Обновление литерального свойства
 */
 export const updateObjectProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> <http://csi.semanticpro.org/temp> } '+
 ' INSERT { <http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> <http://csi.semanticpro.org/temp> }'+
 ' WHERE {}';

 class UpdateObjectProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, predicat, oldValue, newValue){
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].delete[0].triples[0]["object"].id = oldValue;
        this._request.updates[0].insert[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].insert[0].triples[0]["predicate"].id = predicat;
        this._request.updates[0].insert[0].triples[0]["object"].id = newValue;
    }
};

export const UpdateObjectPropertyRequest = registerRequest(
    new UpdateObjectProperty(updateObjectProperty_sparql, admsAssets_graph)
);

/**
 * Получение списка индивидуалов
 */
 const namedIndividuals_sparql = 'PREFIX RDF_TYPE: <http://www.w3.org/2002/07/owl#NamedIndividual> '+
 ' select DISTINCT ?subject '+
 ' where { ?subject <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> RDF_TYPE: } ';
 
class NamedIndividuals extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setType(iri){
        this._request.where[0].triples[0]["object"].value = iri;
        this._request.prefixes.RDF_TYPE = iri;
    }
};

export const NamedIndividualsRequest = registerRequest(
    new NamedIndividuals(namedIndividuals_sparql, admsAssets_graph)
);

/** Удаляет свойство */
const deleteLiteralValueInProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> "" } '+
' INSERT { } WHERE {}';
const deleteLinkValueInProperty_sparql = ' DELETE {<http://csi.semanticpro.org/temp> <http://www.w3.org/2000/01/rdf-schema#label> <http://csi.semanticpro.org/temp> } '+
' INSERT { } WHERE {}';
class DeleteValueInProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, predicat, value){
        this._request.updates[0].delete[0].triples[0]["subject"].id = IRI;
        this._request.updates[0].delete[0].triples[0]["predicate"].id = predicat;
        if (value.startsWith("http"))
            this._request.updates[0].delete[0].triples[0]["object"].id = value;
        else
            this._request.updates[0].delete[0].triples[0]["object"].id = "\""+value+"\"";
    }
};
export const DeleteLiteralValueInPropertyRequest = registerRequest(
    new DeleteValueInProperty(deleteLiteralValueInProperty_sparql, admsAssets_graph)
);
export const DeleteLinkValueInPropertyRequest = registerRequest(
    new DeleteValueInProperty(deleteLinkValueInProperty_sparql, admsAssets_graph)
);

/** Проверяет наличие графа (точнее возрвзвращает запись, если граф есть) */
const selectGraphByURI_sparql = 'PREFIX IRI: <http://view.hbz.ru/> '+
' SELECT DISTINCT ?URI WHERE {' +
' GRAPH ?URI {?s a ?o} . '+
' FILTER (?URI = IRI:) }';
class SelectGraphByURI extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setGraph(IRI){
        this._request.prefixes.IRI = IRI;
        this._request.where[1].expression.args[1].value = IRI;
    }
};
export const SelectGraphByURIRequest = new SelectGraphByURI(selectGraphByURI_sparql, admsAssets_graph)

/** SPARQL получения списка значений http://www.w3.org/2000/01/rdf-schema#range */
const selectRangeInProperty_sparql = 
'PREFIX IRI: <http://www.w3.org/2004/02/skos/core#inScheme> '+
' select ?object '+
' where { IRI: <http://www.w3.org/2000/01/rdf-schema#range> ?object }';

class SelectRangeInProperty extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setProperty(IRI){
        this._request.where[0].triples[0]["subject"].value = IRI;
        this._request.prefixes.IRI = IRI;
    }
};
export const SelectRangeInPropertyRequest = registerRequest(
    new SelectRangeInProperty(selectRangeInProperty_sparql, admsAssets_graph)
);

/** SPARQL получения списка свойств у которых в значении http://www.w3.org/2000/01/rdf-schema#domain задан тип */
const selectPropertyByDomain_sparql = 
'PREFIX IRI: <http://www.w3.org/2004/02/skos/core#inScheme> '+
' select ?property '+
' where { ?property <http://www.w3.org/2000/01/rdf-schema#domain> IRI: }';

class SelectPropertyByDomain extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setDomain(IRI){
        this._request.where[0].triples[0]["object"].value = IRI;
        this._request.prefixes.IRI = IRI;
    }
};
export const SelectPropertyByDomainRequest = registerRequest(
    new SelectPropertyByDomain(selectPropertyByDomain_sparql, admsAssets_graph)
);

const selectAllPoperty_sparql = 
'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX owl: <http://www.w3.org/2002/07/owl#> '+
'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> '+
'SELECT DISTINCT ?property ?label ?domain '+
'WHERE { '+
'  ?property rdf:type ?propertyType . '+
'  FILTER(?propertyType IN (rdf:Property, owl:ObjectProperty, owl:DatatypeProperty, owl:AnnotationProperty)) '+
'  OPTIONAL {  '+
'    ?property rdfs:label ?label . '+
'    FILTER(LANG(?label) = "ru" || LANG(?label) = "" || !isLiteral(?label)) '+
'  } '+
'  OPTIONAL { ?property rdfs:domain ?domain . } '+
'}  '+
' ORDER BY ?label ?property';

class SelectAllPopertyClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
};
export const SelectAllPopertyRequest = registerRequest(
    new SelectAllPopertyClass(selectAllPoperty_sparql, admsAssets_graph)
);


/** Получение количества элементов с заданным типом */
const rdfTypeCount_sparql= 'select (COUNT(distinct ?IRI) AS ?cnt) '+
'WHERE { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2002/07/owl#NamedIndividual> }';
class RdfTypeCount extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }

    setRdfType(rdfType){
        this._request.where[0].triples[0]["object"].value = rdfType;
    }
    cloneOriginal() {return new RdfTypeCount(this._pattern, this._graph); };
};
export const RdfTypeCountRequest = registerRequest(
    new RdfTypeCount(rdfTypeCount_sparql, admsAssets_graph)
);

/** Вставка ссылок на карточки в публичный каталог по результатам поиска */
const sksaIncludeAssets_sparql = 'INSERT { <'+settings.catalog.public+'> <http://www.w3.org/ns/dcat#dataset> ?IRI } '+
'WHERE { '+
'  <'+settings.catalog.signed+'> <http://www.w3.org/ns/dcat#dataset> ?IRI.' +
'}';

const SksaIncludeAssets = registerRequest(new Request(sksaIncludeAssets_sparql, admsAssets_graph));
export const SksaIncludeAssetsRequest = () => {
    return SksaIncludeAssets;
}

/** Исключение ссылок на карточки из публичного каталога по результатам поиска */
const sksaExcludeAssets_sparql = 'DELETE { <'+settings.catalog.public+'> <http://www.w3.org/ns/dcat#dataset> ?IRI } '+
'WHERE { '+
'  <'+settings.catalog.public+'> <http://www.w3.org/ns/dcat#dataset> ?IRI.' +
'}';

const SksaExcludeAssets = registerRequest(new Request(sksaExcludeAssets_sparql, admsAssets_graph));
export const SksaExcludeAssetsRequest = () => {
    return SksaExcludeAssets;
}

/** Список всех каталогов во всех графах  */
const sksaCatalogs_sparql = 'select distinct ?graph ?catalog '+
'where { graph ?graph {?catalog <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/dcat#Catalog>} } ';

class SksaCatalogsClass extends Request {
    constructor(sparql, graph = null){ 
        super(sparql, graph); 
    };
    cloneOriginal() {return new SksaCatalogsClass(sksaCatalogs_sparql, this._graph); };
    
    setGraphs(graphIRIs = []){
        if (Array.isArray(graphIRIs) && graphIRIs.length>0)
            this._request.where.push({
                type: 'filter',
                expression: {
                    type: 'operation',
                    operator: 'in',
                    args: [{termType: 'Variable',value: 'graph'},
                    graphIRIs.map(iri => ({
                        termType: 'NamedNode',
                        value: iri
                    }))
                    ]
                }
            });
    }
};
export const SksaCatalogsRequest = new SksaCatalogsClass(sksaCatalogs_sparql, "");

/** Количество доступных каталогов в различных графах */
const sksaCatalogsCount_sparql = 'SELECT (COUNT(*) AS ?count) '+
'WHERE { { '+
'    SELECT DISTINCT ?graph ?catalog '+
'    WHERE {      GRAPH ?graph {        ?catalog <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/dcat#Catalog> .      }    } '+
'  } }';
class SksaCatalogsCountClass extends Request {
    constructor(sparql, graph = null){ 
        super(sparql, graph); 
    };
    cloneOriginal() {return new SksaCatalogsCountClass(sksaCatalogsCount_sparql, this._graph); };
    
    setGraphs(graphIRIs = []){
        if (Array.isArray(graphIRIs) && graphIRIs.length>0)
            this._request.where.push({
                type: 'filter',
                expression: {
                    type: 'operation',
                    operator: 'in',
                    args: [{termType: 'Variable',value: 'graph'},
                    graphIRIs.map(iri => ({
                        termType: 'NamedNode',
                        value: iri
                    }))
                    ]
                }
            });
    }
};
export const SksaCatalogsCountRequest = new SksaCatalogsCountClass(sksaCatalogsCount_sparql, "");

/** Статистика по элемента каталога в графе  */
const sksaElementCatalogsCount_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> '+
'PREFIX dcat: <http://www.w3.org/ns/dcat#> '+
'PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
'SELECT  (COUNT(DISTINCT ?resource) AS ?resourceCount)  '+
' (COUNT(DISTINCT ?conceptScheme) AS ?conceptSchemeCount) '+
' (COUNT(DISTINCT ?catalog) AS ?catalogCount)'+
'WHERE { '+
'    OPTIONAL { '+
'      ?resource rdf:type ?resourceType . '+
'      ?resourceType rdfs:subClassOf* dcat:Resource . '+
'    } '+
'    OPTIONAL { ?conceptScheme rdf:type skos:ConceptScheme . } '+
'    OPTIONAL { ?catalog rdf:type dcat:Catalog . } '+
'}';
class SksaElementCatalogsCountClass extends Request {
    constructor(sparql, graph = null){ 
        super(sparql, graph); 
    };
};
export const SksaElementCatalogsCountRequest = new SksaElementCatalogsCountClass(sksaElementCatalogsCount_sparql, "");

/************************************************************************************************** */
//                     SSSS   K   K   OOOO    SSSS   
//                    S    S  K  K   O    O  S    S
//                    S       K K    O    O  S
//                     SSSS   KK     O    O   SSSS
//                         S  K K    O    O       S
//                    S    S  K  K   O    O  S    S
//                     SSSS   K   K   OOOO    SSSS
/************************************************************************************************** */

/** Получение списка всех концептов из схемы */
class SkosConceptInScheme extends Request {
    constructor(sparql, graph = null){ 
        super(sparql, graph); 
    };
    setConceptScheme(taxonomy){
        this._request.where[0].triples[2]["object"].value = taxonomy;
        this._request.prefixes.IRI_SCHEMA = taxonomy;
    }
};
const skosConceptInScheme_sparql= 'PREFIX IRI_SCHEMA: <http://csi.semanticpro.org/authority/language>'+
' select ?IRI ?Label '+
' where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#Concept> .'+
'    ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?Label .'+
'    ?IRI <http://www.w3.org/2004/02/skos/core#inScheme> IRI_SCHEMA: }';
export const skosConceptInScheme = registerRequest(new SkosConceptInScheme(skosConceptInScheme_sparql, admsAssets_graph));

/** Получение списка связей концептов из схемы */
class SkosConceptInSchemeBroader extends Request {
    constructor(sparql, graph = null){ 
        super(sparql, graph); 
    };
    setConceptScheme(taxonomy){
        this._request.where[0].triples[2]["object"].value = taxonomy;
        this._request.prefixes.IRI_SCHEMA = taxonomy;
    }
};
const skosConceptInSchemeBroader_sparql= 'PREFIX IRI_SCHEMA: <http://csi.semanticpro.org/authority/language>'+
' select ?IRI ?broader '+
' where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#Concept> .'+
'    ?IRI <http://www.w3.org/2004/02/skos/core#broader> ?broader .'+
'    ?IRI <http://www.w3.org/2004/02/skos/core#inScheme> IRI_SCHEMA: }';
export const skosConceptInSchemeBroader = registerRequest(
    new SkosConceptInSchemeBroader(skosConceptInSchemeBroader_sparql, admsAssets_graph)
);

/** Получение списка dsc:identifier концептов из схемы */
class SkosConceptInSchemeIdentifier extends Request {
    constructor(sparql, graph = null){ 
        super(sparql, graph); 
    };
    setConceptScheme(taxonomy){
        this._request.where[0].triples[2]["object"].value = taxonomy;
        this._request.prefixes.IRI_SCHEMA = taxonomy;
    }
};
const skosConceptInSchemeIdentifier_sparql= 'PREFIX IRI_SCHEMA: <http://csi.semanticpro.org/authority/language>'+
' select ?IRI ?identifier '+
' where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#Concept> .'+
'    ?IRI <http://purl.org/dc/terms/identifier> ?identifier .'+
'    ?IRI <http://www.w3.org/2004/02/skos/core#inScheme> IRI_SCHEMA: }';
export const skosConceptInSchemeIdentifier = registerRequest(
    new SkosConceptInSchemeIdentifier(skosConceptInSchemeIdentifier_sparql, admsAssets_graph)
);

/** Получение количества СА/нСД связанных с каталогом default_catalog 
 * и имеющих связь с концептом */
const skosConceptLinkCount_sparql= 'select ?theme (COUNT(distinct ?IRI) AS ?cnt) '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI. '+
'    ?IRI <http://www.w3.org/ns/dcat#theme> ?theme. '+
'    FILTER(?theme = <http://hbz.ru/skos/Dictionary>) }'+
' group by ?theme';

class SkosConceptLinkCount extends Request {

    constructor(sparql, graph = null){ super(sparql, graph); }

    setConceptIRI(uri){
        this._request.where[1].expression.args[1].value = uri;
    }
    cloneOriginal() {
        const request = new SkosConceptLinkCount(this._pattern, this._graph); 
        request._request.where[0].triples[0]["subject"].value = settings.catalog.iri;
        return request;
    };
};

const skosConceptLinkCount = registerRequest(
    new SkosConceptLinkCount(skosConceptLinkCount_sparql, admsAssets_graph)
);
export const SkosConceptLinkCountRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        skosConceptLinkCount._request.where[0].triples[0]["subject"].value = catalogIRI;
    return skosConceptLinkCount;
}

/** Получение концептов и их количества у СА/нСД связанных с каталогом default_catalog */
const skosConceptsLinkCount_sparql= 'select ?theme (COUNT(distinct ?IRI) AS ?cnt) '+
'WHERE { <'+default_catalog+'> <http://www.w3.org/ns/dcat#dataset> ?IRI. '+
'    ?IRI <http://www.w3.org/ns/dcat#theme> ?theme. }'+
' group by ?theme';
class SkosConceptsLinkCount extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    cloneOriginal() {
        const request = new SkosConceptsLinkCount(this._pattern, this._graph); 
        request._request.where[0].triples[0]["subject"].value = settings.catalog.iri;
        return request;
    };
};
const skosConceptsLinkCount = registerRequest(
    new SkosConceptsLinkCount(skosConceptsLinkCount_sparql, admsAssets_graph)
);
export const SkosConceptsLinkCountRequest = (catalogIRI = settings.catalog.iri ) => {
    if (catalogIRI)
        skosConceptsLinkCount._request.where[0].triples[0]["subject"].value = catalogIRI;
    return skosConceptsLinkCount;
}

/** Получение списка доступных skos:ConceptScheme */
const skosSchemes_sparql_old = 'SELECT ?IRI ?dsn ?dsv ?dcp ?catalog '+
'WHERE { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#ConceptScheme> .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER((LANG(?dcp)) = "ru") } .'+
'  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn)'+
'} order by ?dsn';

const skosSchemes_sparql =
'SELECT DISTINCT ?IRI ?dsn ?dst ?dsv ?dsp ' +
'WHERE { ' +
'  ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#ConceptScheme> . ' +
/* skos:prefLabel -> dsn */
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#prefLabel> ?dsn_main . FILTER(LANG(?dsn_main) = "ru") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#prefLabel> ?dsn_en . FILTER(LANG(?dsn_en) = "en") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#prefLabel> ?dsn_empty . FILTER(LANG(?dsn_empty) = "") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#prefLabel> ?dsn_any } . ' +

/* rdfs:label -> dst */
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dst_main . FILTER(LANG(?dst_main) = "ru") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dst_en . FILTER(LANG(?dst_en) = "en") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dst_empty . FILTER(LANG(?dst_empty) = "") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dst_any } . ' +

/* owl:versionInfo -> dsv */
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } . ' +

/* skos:definition -> dsp */
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#definition> ?dsp_main . FILTER(LANG(?dsp_main) = "ru") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#definition> ?dsp_en . FILTER(LANG(?dsp_en) = "en") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#definition> ?dsp_empty . FILTER(LANG(?dsp_empty) = "") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#definition> ?dsp_any } . ' +

'  BIND(COALESCE(?dsn_main, ?dsn_en, ?dsn_empty, ?dsn_any) AS ?dsn_label) . ' +
'  BIND(COALESCE(?dst_main, ?dst_en, ?dst_empty, ?dst_any) AS ?dst) . ' +
'  BIND(COALESCE(?dsp_main, ?dsp_en, ?dsp_empty, ?dsp_any) AS ?dsp) . ' +
'  BIND(COALESCE(?dsn_label, ?dst) AS ?dsn) . '+
'} ' +
'ORDER BY ?dsn';

class SkosSchemesClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setLang(lang){
        this._request.where[1].patterns[1].expression.args[1].value = lang;
        this._request.where[5].patterns[1].expression.args[1].value = lang;
        this._request.where[10].patterns[1].expression.args[1].value = lang;
    }
    cloneOriginal() {return new SkosSchemesClass(this._pattern, this._graph); };
};

export const SkosSchemesRequest = registerRequest(
    new SkosSchemesClass(skosSchemes_sparql, admsAssets_graph)    
);

/** Получение количества доступных схем */
const skosSchemesCount_sparql = 'select (COUNT(distinct ?IRI) AS ?count) '+
'where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#ConceptScheme> .}' ;
class SkosSchemesCount extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    fixVariable(){
        console.log("request.js SkosSchemesCount", this._request);
        for (let index = 0; index < this._request.where[0].triples.length; index++) {
            const element = this._request.where[0].triples[index];
            if (element["subject"].id == '?http://www.w3.org/2004/02/skos/core#ConceptScheme')
                element["subject"].id = "?IRI";
        };
    }
    cloneOriginal() {return new SkosSchemesCount(this._pattern, this._graph); };
};
export const SkosSchemesCountRequest = registerRequest(
    new SkosSchemesCount(skosSchemesCount_sparql, admsAssets_graph)
);


const skosSchemesIRI_sparql = 'select ?IRI '+
'where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#ConceptScheme> .}' ;
class SkosSchemesIRIClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    
    fixVariable(){
        for (let index = 0; index < this._request.where[0].triples.length; index++) {
            const element = this._request.where[0].triples[index];
            if (element["subject"].id == '?http://www.w3.org/2004/02/skos/core#ConceptScheme')
                element["subject"].id = "?IRI";
        };
    }
    cloneOriginal() {return new SkosSchemesCount(this._pattern, this._graph); };
};
export const SkosSchemesIRIRequest = registerRequest(
    new SkosSchemesIRIClass(skosSchemesIRI_sparql, admsAssets_graph)
);


/** Получение IRI каталогов, в которых используется схема для таксономии активов */
const skosSchemeInCatalog_sparql = 'SELECT ?IRI '+
'  WHERE { ?IRI <http://www.w3.org/ns/dcat#themeTaxonomy> <http://catalog.ru/sa> }';
class SkosSchemeInCatalog extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setConceptScheme(IRI){
        this._request.where[0].triples[0]["object"].value = IRI;
    }
};
export const SkosSchemeInCatalogRequest = registerRequest(
    new SkosSchemeInCatalog(skosSchemeInCatalog_sparql, admsAssets_graph)
);

const skosDescription_sparql = ' select DISTINCT ?definition ?comment ?dctd ?description '+
' WHERE { ' +
'   VALUES ?IRI { <http://localhost/sksa/iri> }  ' +
'   ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#ConceptScheme> . '+
'   OPTIONAL { ?IRI <http://www.w3.org/2004/02/skos/core#definition> ?definition . } '+
'   OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#comment> ?comment . } '+
'   OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dctd . }  '+
'   BIND(COALESCE(?definition, ?comment, ?dctd) AS ?description) . ' +
'}';

/** Получить информацию об описании (description или definition) по IRI субъекта http://purl.org/dc/terms/description  */
class SkosDescriptionClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }
    setURI(iri){
        this._request.where[0].values[0]["?IRI"].value = iri;
        // this._request.where[1].patterns[0].triples[0].subject.value = iri;
        // this._request.where[2].patterns[0].triples[0].subject.value = iri;
        // this._request.where[3].patterns[0].triples[0].subject.value = iri;
    }
};
export const SkosDescriptionRequest = registerRequest(
    new SkosDescriptionClass(skosDescription_sparql, default_graph)
);


/** Получение количества связанных со схемой концептов */
const skosConceptInSchemeCount_sparql= 'select (COUNT(distinct ?IRI) AS ?cnt) '+
'WHERE { ?IRI <http://www.w3.org/2004/02/skos/core#inScheme> <http://purl.sempnticpro.org/skos/ConceptScheme> }';
class SkosConceptInSchemeCount extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); }

    setConceptScheme(IRI){
        this._request.where[0].triples[0]["object"].value = IRI;
    }
    cloneOriginal() {return new SkosConceptInSchemeCount(this._pattern, this._graph); };
};

export const SkosConceptInSchemeCountRequest = registerRequest(
    new SkosConceptInSchemeCount(skosConceptInSchemeCount_sparql, admsAssets_graph)
);

/** Добавление нового концепта  */
export const skosNewConcept_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { '+
' IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/2004/02/skos/core#Concept> . '+
' IRI: <http://www.w3.org/2004/02/skos/core#inScheme> <http://purl.sempnticpro.org/skos/ConceptScheme> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Concept Name" } '+
' WHERE {}'
class SkosNewConcept extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, label, scheme){
        this._request.updates[0].insert[0].triples[0]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["object"].value = scheme;
        this._request.updates[0].insert[0].triples[2]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[2]["object"].value = label;
        this._request.prefixes.IRI = IRI;
    }
    /** Установить ТИП */
    setType(IRI){
        this._request.updates[0].insert[0].triples[0]["object"].value = IRI;
    }
};
export const SkosNewConceptRequest = registerRequest(
    new SkosNewConcept(skosNewConcept_sparql, admsAssets_graph)
);

/** Список концептов не привязанных ни к одной из схем  */
export const skosNotInSchemeConcepts_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
'SELECT DISTINCT ?concept '+
' WHERE { ?concept rdf:type skos:Concept . ' +
'  FILTER NOT EXISTS { '+
'    ?concept skos:inScheme ?scheme . '+
'  } '+
'} '+
' ORDER BY ?concept';

class SkosNotInSchemeConcepts extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
};
export const SkosNotInSchemeConceptsRequest = registerRequest(
    new SkosNotInSchemeConcepts(skosNotInSchemeConcepts_sparql, admsAssets_graph)
);

/** Список концептов  привязанных хотя бы к одной из схем  */
export const skosInSchemeConcepts_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
'SELECT DISTINCT ?concept '+
' WHERE { ?concept rdf:type skos:Concept . ' +
'   ?concept skos:inScheme ?scheme . ' +
'} '+
' ORDER BY ?concept';

class SkosInSchemeConcepts extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
};
export const SkosInSchemeConceptsRequest = registerRequest(
    new SkosInSchemeConcepts(skosInSchemeConcepts_sparql, admsAssets_graph)
);


/** Список всех концептов  */
export const skosConcepts_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
'SELECT DISTINCT ?concept '+
' WHERE { ?concept rdf:type skos:Concept . ' +
'} '+
' ORDER BY ?concept';

class SkosConcepts extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
};
export const SkosConceptsRequest = registerRequest(
    new SkosInSchemeConcepts(skosInSchemeConcepts_sparql, admsAssets_graph)
);

/** Исключение линка на концепт в классификаторе  */
class SkosUnlinkConceptInSchemeClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setIRIs(SIRI, CIRI){
        this._request.updates[0].where[0].expression.value = SIRI;
        this._request.updates[0].where[1].expression.value = CIRI;
    }
};
export const skosUnlinkConcept_sparql = 'PREFIX SIRI: <http://localhost/sksa/siri> '+
'PREFIX CIRI: <http://localhost/sksa/ciri> '+
'PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
'DELETE { '+
'  ?concept skos:inScheme ?scheme . '+
'  ?scheme skos:hasTopConcept ?concept . '+
'  ?concept skos:topConceptOf ?scheme . '+
'} '+
'WHERE { '+
'  BIND( SIRI: AS ?scheme) '+
'  BIND( CIRI: AS ?concept) '+
'  OPTIONAL { ?concept skos:inScheme ?scheme . } '+
'  OPTIONAL { ?scheme skos:hasTopConcept ?concept . } '+
'  OPTIONAL { ?concept skos:topConceptOf ?scheme . } '+
'} ';


export const SkosUnlinkConceptInSchemeRequest = registerRequest(new SkosUnlinkConceptInSchemeClass(skosUnlinkConcept_sparql, admsAssets_graph));

const skosCounUsedConceptsInScheme_sparql = ' PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
' PREFIX dcat: <http://www.w3.org/ns/dcat#> '+
' SELECT (COUNT(?dataset) AS ?themeUsageCount) '+
' WHERE { ' +
'  ?concept a skos:Concept ; '+
'           skos:inScheme <http://purl.semanticpro.org/authority/section> . '+
'  ?dataset dcat:theme ?concept .'


/** Установка новой связи с элементом в каталоге */
const skosLinkConcept_sparql = 'PREFIX skos: <http://www.w3.org/2004/02/skos/core#> '+
' DELETE {} '+
' INSERT {  ?concept skos:inScheme ?scheme . ?concept skos:topConceptOf ?scheme . ?scheme skos:hasTopConcept ?concept . } '+
' WHERE { VALUES (?concept ?scheme) { ( '+
'      <http://purl.semanticpro.org/sksa/Concept1> '+
'      <http://purl.semanticpro.org/sksa/ConceptScheme1>  '+
'    ) '+
'  } '+
'} '

class LinkConceptInSchemeClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValue(scheme, concept){
        this._request.updates[0].where[0].values[0]["?concept"].value = concept;
        this._request.updates[0].where[0].values[0]["?scheme"].value = scheme;        
    }
};
export const LinkConceptInSchemeRequest = registerRequest(new LinkConceptInSchemeClass(skosLinkConcept_sparql, admsAssets_graph));

/** Уникальный список IRI у которых тип skos:Collection или skos:OrderedCollection 
 * и предикаты skos:member или skos:memberList содержат хотя-бы один IRI
*/
const skosCollectionByConcepts_sparql = `PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
SELECT DISTINCT ?collection
WHERE { VALUES ?concept { <http://localhost/sksa/concept/1> <http://localhost/sksa.concept/2> }

  ?collection rdf:type ?type .

  VALUES ?type { skos:Collection skos:OrderedCollection }

  { ?collection skos:member ?concept . }
  UNION { ?collection skos:memberList ?list . ?list rdf:rest*/rdf:first ?concept . }
}
ORDER BY ?collection`;

class CollectionByConceptsClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setIRIs(iris){
        this._request.where[0].values = iris.map(iri => ({"?concept": namedNode(iri)}));
    }
};
export const CollectionByConceptsRequest = registerRequest(new CollectionByConceptsClass(skosCollectionByConcepts_sparql, admsAssets_graph));
/***************************************************************************************************/
//                 V     V  OOOO    CCCC    AAAA   BBBBB    SSSS   
//                 V     V O    O  C    C  A    A  B    B  S    S
//                  V   V  O    O  C       A    A  B    B  S
//                  V   V  O    O  C       A    A  BBBBB    SSSS
//                   V V   O    O  C       AAAAAA  B    B       S
//                   V V   O    O  C    C  A    A  B    B  S    S
//                    V     OOOO    CCCC   A    A  BBBBB    SSSS
/***************************************************************************************************/

/** Получение списка доступных индивидуалов */
const vocabs_sparql_old = 'SELECT distinct ?IRI ?dsn ?dsv ?dcp '+
'WHERE { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?rdfType . '+
'  FILTER (?rdfType IN (<http://purl.org/dc/terms/LinguisticSystem>, <http://purl.org/dc/terms/LicenseDocument>)) .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_1 FILTER( (LANG(?dsn_1)) = "" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_2 FILTER( (LANG(?dsn_2)) = "ru" )} .'+
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/title> ?dct_1 FILTER( (LANG(?dct_1)) = "" )} .'+
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/title> ?dct_2 FILTER( (LANG(?dct_2)) = "ru" )} .'+
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } .'+
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER((LANG(?dcp)) = "ru") } .'+
'  BIND ( IF(STRLEN(?dct_2) > 0, ?dct_2, ?dct_1) as ?dct) .'+
'  BIND ( IF(STRLEN(?dsn_2) > 0, ?dsn_2, ?dsn_1) as ?dsn_0) .'+
'  BIND ( IF(STRLEN(?dsn_0) > 0, ?dsn_0, ?dct) as ?dsn)'+
'} order by ?dsn';

const vocabs_sparql =
'SELECT DISTINCT ?IRI ?dsn ?dst ?dsv ?dsp ' +
'WHERE { ' +
'  ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?rdfType . ' +
'  FILTER (?rdfType IN ( <http://purl.org/dc/terms/LinguisticSystem>, <http://purl.org/dc/terms/LicenseDocument> )) . ' +
/* rdfs:label -> dsn */
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_main . FILTER(LANG(?dsn_main) = "ru") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_en . FILTER(LANG(?dsn_en) = "en") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_empty . FILTER(LANG(?dsn_empty) = "") } . ' +
'  OPTIONAL { ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn_any } . ' +

/* dcterms:title -> dst */
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/title> ?dst_main . FILTER(LANG(?dst_main) = "ru") } . ' +
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/title> ?dst_en . FILTER(LANG(?dst_en) = "en") } . ' +
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/title> ?dst_empty . FILTER(LANG(?dst_empty) = "") } . ' +
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/title> ?dst_any } . ' +

/* owl:versionInfo -> dsv */
'  OPTIONAL { ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv } . ' +

/* dcterms:description -> dsp */
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dsp_main . FILTER(LANG(?dsp_main) = "ru") } . ' +
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dsp_en . FILTER(LANG(?dsp_en) = "en") } . ' +
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dsp_empty . FILTER(LANG(?dsp_empty) = "") } . ' +
'  OPTIONAL { ?IRI <http://purl.org/dc/terms/description> ?dsp_any } . ' +

'  BIND(COALESCE(?dsn_main, ?dsn_en, ?dsn_empty, ?dsn_any) AS ?dsn_label) . ' +
'  BIND(COALESCE(?dst_main, ?dst_en, ?dst_empty, ?dst_any) AS ?dst) . ' +
'  BIND(COALESCE(?dsp_main, ?dsp_en, ?dsp_empty, ?dsp_any) AS ?dsp) . ' +
'  BIND(COALESCE(?dsn_label, ?dst) AS ?dsn) . '+
'} ' +
'ORDER BY ?dsn';

class Vocabs extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    /** Установить ТИПЫ */
    setTypes(rdfTypes){
        this._request.where[1].expression.args[1] = rdfTypes.map(type => namedNode(type));
    }
    setLang(lang){
        this._request.where[2].patterns[1].expression.args[1].value = lang;
        this._request.where[6].patterns[1].expression.args[1].value = lang;
        this._request.where[11].patterns[1].expression.args[1].value = lang;
    }
    cloneOriginal() {return new Vocabs(this._pattern, this._graph); };
};
export const VocabsRequest = registerRequest(new Vocabs(vocabs_sparql, admsAssets_graph));

/** Получить только список IRI по реестру объектов  */
const vocabsIRI_sparql = 'select distinct ?IRI '+
'WHERE { ' +
'  ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?rdfType . ' +
'  FILTER (?rdfType IN ( <http://purl.org/dc/terms/LinguisticSystem>, <http://purl.org/dc/terms/LicenseDocument> )) . ' +
'} ';

class VocabsIRIClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    /** Установить ТИПЫ */
    setTypes(rdfTypes){
        this._request.where[1].expression.args[1] = rdfTypes.map(type => namedNode(type));
    }
    cloneOriginal() {return new VocabsIRIClass(this._pattern, this._graph); };
};
export const VocabsIRIRequest = registerRequest(new VocabsIRIClass(vocabsIRI_sparql, admsAssets_graph));

/** Получение количества доступных индивидуалов */
const vocabsCount_sparql = 'select (COUNT(distinct ?IRI) AS ?count) '+
'where { ?IRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?rdfType .'+
'  FILTER (?rdfType IN (<http://purl.org/dc/terms/LinguisticSystem>, <http://purl.org/dc/terms/LicenseDocument>))}' ;
class VocabsCount extends Vocabs {
    constructor(sparql, graph = null){ super(sparql, graph); };
    fixVariable(){
    };
    cloneOriginal() {return new VocabsCount(this._pattern, this._graph); };
};
export const VocabsCountRequest = registerRequest(new VocabsCount(vocabsCount_sparql, admsAssets_graph));

/** Добавление нового элемента */
class NewIndividualClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValues(IRI, type, label, lang){        
        this._request.updates[0].insert[0].triples[0]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[1]["subject"].value = IRI;
        this._request.updates[0].insert[0].triples[0]["object"].value = type;
        this._request.updates[0].insert[0].triples[1]["object"].value = label;
        this._request.updates[0].insert[0].triples[1]["object"].language = (lang)?lang:"";
        this._request.prefixes.IRI = IRI;
    }
};
const vocabsNewElement_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
' DELETE {} '+
' INSERT { IRI: <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> <http://www.w3.org/ns/dcat#Dataset> . '+
' IRI: <http://www.w3.org/2000/01/rdf-schema#label> "Name" }'+
' WHERE {}'
export const NewIndividualRequest = registerRequest(new NewIndividualClass(vocabsNewElement_sparql, admsAssets_graph));

// const vocabsDeleteElement_sparql = 'PREFIX IRI: <http://purl.org/dc/terms/n3> '+
// 'DELETE { ?iri ?p ?o . } '+
// 'WHERE { VALUES ?iri { IRI: }  ?iri ?p ?o . }; '+
// 'DELETE { ?s ?p ?iri . } '+
// 'WHERE { VALUES ?iri { IRI: } ?s ?p ?iri . }; ';
// class DeleteIndividualClass extends Request {
//     constructor(sparql, graph = null){ super(sparql, graph); };
//     setIRI(IRI){
//         this._request.updates[0].where[0].values[0]["?iri"].value = IRI;
//         this._request.updates[1].where[0].values[0]["?iri"].value = IRI;
//         this._request.prefixes.IRI = IRI;
//     }
// };

//Получение информации о доступных в каталоге языках. Возвращает набор триплетов 
const linguisticSystem_sparql = 'PREFIX dcat: <http://www.w3.org/ns/dcat#> '+
'PREFIX dcterms: <http://purl.org/dc/terms/> '+
'SELECT DISTINCT ?s ?p ?o '+
'WHERE { '+
'  VALUES ?catalog { <'+default_catalog+'> } '+
'  ?catalog a dcat:Catalog ; '+
'           dcterms:language ?s . '+
'  ?s ?p ?o . '+
'} '+
'ORDER BY ?s ?p ?o ';
class LinguisticSystemClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setValue(catalogIRI){
        this._request.where[0].values[0]["?catalog"].value = catalogIRI;
    }
};
const linguisticSystem = registerRequest(new LinguisticSystemClass(linguisticSystem_sparql, admsAssets_graph));

export const LinguisticSystemRequest = (catalogIRI = settings.catalog.iri) => {
    if (catalogIRI)
        linguisticSystem.setValue(catalogIRI);
    return linguisticSystem;
}

/***************************************************************************************************/
//                   EEEEEE         N     N         OOOO  
//                   E              NN    N         O    O 
//                   E              N N   N         O     O
//                   EEEE           N  N  N         O     O
//                   E              N   N N         O     O
//                   E              N    NN         O    O 
//                   EEEEE          N     N         OOOO 
/***************************************************************************************************/

/***************************************************************************************************/
//                   EEEEEE  X     X   PPPPPP    OOOOO   RRRRRR   TTTTTTT
//                   E        X   X    P     P  O     O  R     R     T
//                   E         X X     P     P  O     O  R     R     T
//                   EEEE       X      PPPPPP   O     O  RRRRRR      T
//                   E         X X     P        O     O  R R         T
//                   E        X   X    P        O     O  R   R       T
//                   EEEEE   X     X   P         OOOOO   R    R      T
/***************************************************************************************************/

/** Запрос для получение ttl с данными карточками Получение количества доступных индивидуалов */
const exportAsset_sparql = 'construct {?s ?p ?o} '+
'where { ?s ?p ?o .'+
'  FILTER (?s IN (<http://localhost/sksa/card/Asset>))}' ;

class ExportAsset extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    /** Установить IRI, по которым должны быть получены данные */
    setIRIs(IRIs){
        this._request.where[1].expression.args[1] = IRIs.map(IRI => namedNode(IRI));
    }
    cloneOriginal() {return new ExportAsset(this._pattern, this._graph); };
};

export const ExportAssetRequest = registerRequest(new ExportAsset(exportAsset_sparql, admsAssets_graph));
export const ExportSubjectRequest = registerRequest(new ExportAsset(exportAsset_sparql, admsAssets_graph));

/** Построение текста запроса для экспорта данных по субъекту(-ам) */
export const buildExportAsset_sparql = (uris) => `CONSTRUCT {?s ?p ?o}
WHERE {
  {
    VALUES ?s { ${uris.map((uri) => `<${uri}>`).join("\n    ")} }
    ?s ?p ?o .
  }
  UNION {
    VALUES ?root { ${uris.map((uri) => `<${uri}>`).join("\n    ")} } 
    ?root ?p0 ?b0 .
    FILTER(isBlank(?b0))
    ?b0 ?px ?b
    OPTION(TRANSITIVE, T_IN(?b0), T_OUT(?b), T_DISTINCT, T_MIN(0))
    FILTER(isBlank(?b))
    BIND(?b AS ?s)
    ?s ?p ?o .
  }
}` ;


/***************************************************************************************************/
//                   EEEEEE         N     N         OOOO  
//                   E              NN    N         O    O 
//                   E              N N   N         O     O
//                   EEEE           N  N  N         O     O
//                   E              N   N N         O     O
//                   E              N    NN         O    O 
//                   EEEEE          N     N         OOOO 
/***************************************************************************************************/


/************************************************************************************************** */
//                  SSSS   U    U  BBBB      JJJ  EEEEE   CCCC  TTTTT
//                 S    S  U    U  B   B      J   E      C        T
//                 S       U    U  B   B      J   E      C        T
//                  SSSS   U    U  BBBB       J   EEEE   C        T
//                      S  U    U  B   B      J   E      C        T
//                 S    S  U    U  B   B  J   J   E      C        T
//                  SSSS    UUUU   BBBB    JJJ    EEEEE   CCCC    T
/************************************************************************************************** */

/** Получение списка всех субъект->предикат для объекта */
class SubjectPredicatClass extends Request {

    constructor(sparql, graph = null){ super(sparql, graph); }

    setIRI(iri){
        this._request.where[0].triples[0]["object"].value = iri;
        this._request.prefixes.URI = iri;
    };

    cloneOriginal() {return new SubjectPredicatClass(this._pattern, this._graph); };
};
const subjectPredicat_sparql = 'PREFIX IRI: <http://localhost/sksa> '+
' select DISTINCT ?subject ?predicat '+
' where { ?subject ?predicat IRI: } ';
export const SubjectPredicatRequest = registerRequest(new SubjectPredicatClass(subjectPredicat_sparql, admsAssets_graph));


/** Получение количества доступных активов */
const subjectPredicatCount_sparql = 'PREFIX IRI: <http://localhost/sksa> '+
'select (COUNT(distinct ?subject) AS ?count) '+
'where { ?subject ?predicat IRI: .}' ;//+
export const SubjectPredicatCountRequest = registerRequest(new SubjectPredicatClass(subjectPredicatCount_sparql, admsAssets_graph));

/** Получение данных по субъекту */
const subjectRDF_sparql = 'PREFIX base:  <http://purl.semanticpro.org/> '+
'CONSTRUCT { ?resource ?p ?o . } WHERE {  ?resource ?p ?o . } ';

class SubjectRDFClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setIRI(iri){
        this._request.template[0]["subject"] = namedNode(iri);
        this._request.where[0].triples[0]["subject"] = namedNode(iri);
    }
    cloneOriginal() {return new SubjectRDFClass(this._pattern, this._graph); };
};

export const SubjectRDFRequest = registerRequest(new SubjectRDFClass(subjectRDF_sparql, admsAssets_graph));

/***************************************************************************************************/
//                   EEEEEE         N     N         OOOO  
//                   E              NN    N         O    O 
//                   E              N N   N         O     O
//                   EEEE           N  N  N         O     O
//                   E              N   N N         O     O
//                   E              N    NN         O    O 
//                   EEEEE          N     N         OOOO 
/***************************************************************************************************/

/************************************************************************************************** */
//                          OOO   W       W  L
//                         O   O  W       W  L
//                         O   O  W       W  L
//                         O   O  W   W   W  L
//                         O   O   W W W W   L
//                         O   O    W   W    L
//                          OOO     W   W    LLLLL
/************************************************************************************************** */

const sksaOntology_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> '+
'PREFIX owl:  <http://www.w3.org/2002/07/owl#> '+
'CONSTRUCT { ?resource ?p ?o . } '+
'WHERE { '+
'  ?resource a ?type . '+
'  FILTER ( ?type IN (rdfs:Class, owl:Class, rdf:Property, owl:ObjectProperty, owl:DatatypeProperty, owl:AnnotationProperty)) '+
'  ?resource ?p ?o . '+
'} ';
class SKSAOntologClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    cloneOriginal() {return new SKSAOntologClass(this._pattern, this._graph); };
};

export const SKSAOntologRequest = registerRequest(new SKSAOntologClass(sksaOntology_sparql, admsAssets_graph));

const classTree_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> '+
'PREFIX owl:  <http://www.w3.org/2002/07/owl#> '+
'SELECT DISTINCT ?class ?parent ?label ?type '+
'WHERE { '+
'  ?class a ?type . '+
'  FILTER ( ?type IN (rdfs:Class, owl:Class)) '+
'  OPTIONAL { ?class rdfs:subClassOf ?parent . FILTER(isIRI(?parent)) } '+
'  OPTIONAL { ?class rdfs:label ?label . } '+
'} '+
'ORDER BY ?parent ?label ?class';

class ClassTreeClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    cloneOriginal() {return new ClassTreeClass(this._pattern, this._graph); };
};

export const ClassTreeRequest = registerRequest(new ClassTreeClass(classTree_sparql, admsAssets_graph));

const propertyTree_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> '+
'PREFIX owl:  <http://www.w3.org/2002/07/owl#> '+
'SELECT DISTINCT ?property ?parent ?label ?type ?domain ?range '+
'WHERE { '+
'  ?property a ?type . '+
'  FILTER ( ?type IN (rdf:Property, owl:ObjectProperty, owl:DatatypeProperty, owl:AnnotationProperty)) '+
'  OPTIONAL { ?property rdfs:subPropertyOf ?parent . FILTER(isIRI(?parent)) } '+
'  OPTIONAL { ?property rdfs:label ?label . } '+
'  OPTIONAL { ?property rdfs:domain ?domain . } '+
'  OPTIONAL { ?property rdfs:range ?range . } '+
'} '+
'ORDER BY ?parent ?label ?property';

class PropertyTreeClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    cloneOriginal() {return new PropertyTreeClass(this._pattern, this._graph); };
};

export const PropertyTreeRequest = registerRequest(new PropertyTreeClass(propertyTree_sparql, admsAssets_graph));

const treeElementDetails_sparql = 'PREFIX IRI: <http://localhost/sksa> '+
'SELECT DISTINCT ?subject ?predicat ?object ?direction '+
'WHERE { '+
'  { '+
'    BIND(IRI: AS ?subject) '+
'    IRI: ?predicat ?object . '+
'    BIND("out" AS ?direction) '+
'  } '+
'  UNION '+
'  { '+
'    ?subject ?predicat IRI: . '+
'    BIND(IRI: AS ?object) '+
'    BIND("in" AS ?direction) '+
'  } '+
'} '+
'ORDER BY ?direction ?predicat ?object ?subject';

class TreeElementDetailsClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setIRI(iri){
        this._request.prefixes.IRI = iri;
        this._request.where[0].patterns[0].patterns[0].expression.value = iri;
        this._request.where[0].patterns[0].patterns[1].triples[0].subject.value = iri;
        this._request.where[0].patterns[1].patterns[0].triples[0].object.value = iri;
        this._request.where[0].patterns[1].patterns[1].expression.value = iri;
    };
    cloneOriginal() {return new TreeElementDetailsClass(this._pattern, this._graph); };
};

export const TreeElementDetailsRequest = registerRequest(new TreeElementDetailsClass(treeElementDetails_sparql, admsAssets_graph));

/***************************************************************************************************/
//                   EEEEEE         N     N         OOOO  
//                   E              NN    N         O    O 
//                   E              N N   N         O     O
//                   EEEE           N  N  N         O     O
//                   E              N   N N         O     O
//                   E              N    NN         O    O 
//                   EEEEE          N     N         OOOO 
/***************************************************************************************************/

/************************************************************************************************** */
//                  GGGG   RRRR      A     PPPP   H   H
//                 G       R   R    A A    P   P  H   H
//                 G       R   R   A   A   P   P  H   H
//                 G  GG   RRRR    AAAAA   PPPP   HHHHH
//                 G   G   R  R    A   A   P      H   H
//                 G   G   R   R   A   A   P      H   H
//                  GGG    R   R   A   A   P      H   H
/************************************************************************************************** */
/** URI графов, содержащих хотябы один каталог  */
const graphMitCatalog_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
' PREFIX dcat: <http://www.w3.org/ns/dcat#> '+
' SELECT DISTINCT ?graph '+
' WHERE { GRAPH ?graph { ?catalog rdf:type dcat:Catalog . } } '+
'ORDER BY ?graph';
export const GraphMitCatalogRequest = new SPARQLText(graphMitCatalog_sparql, "");


/** Количество каталого в графе */
const graphCatalogInGraphCount_sparql = 'PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
' PREFIX dcat: <http://www.w3.org/ns/dcat#> '+
' SELECT (COUNT(DISTINCT ?catalog) AS ?count) '+
' WHERE {  GRAPH <http://example.org/catalog-graph> { ?catalog rdf:type dcat:Catalog . }'+
'}';

class GraphCatalogInGraphCountClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setGraph(iri){        
        this._request.where[0].name.value = iri;
    };
    cloneOriginal() {return new GraphCatalogInGraphCountClass(this._pattern, this._graph); };
}

export const GraphCatalogInGraphCountRequest = new GraphCatalogInGraphCountClass(graphCatalogInGraphCount_sparql, "");

const graphIncludeSubject_sparql = 'SELECT DISTINCT ?graph ' +
' WHERE {  GRAPH ?graph { <http://example.org/subjectIRI> ?p ?o . } }' +
'ORDER BY ?graph';

class GraphIncludeSubjectClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setIRI(iri){        
        this._request.where[0].patterns[0].triples[0].subject.value = iri;
    };
    cloneOriginal() {return new GraphIncludeSubjectClass(this._pattern, this._graph); };
}

export const GraphIncludeSubjectRequest = new GraphIncludeSubjectClass(graphIncludeSubject_sparql, "");

/***************************************************************************************************/
//                   EEEEEE         N     N         OOOO  
//                   E              NN    N         O    O 
//                   E              N N   N         O     O
//                   EEEE           N  N  N         O     O
//                   E              N   N N         O     O
//                   E              N    NN         O    O 
//                   EEEEE          N     N         OOOO 
/***************************************************************************************************/

/************************************************************************************************** */
//                 SSSS   EEEEE  RRRR   V     V  III   CCCC  EEEEE
//                S    S  E      R   R  V     V   I   C      E
//                S       E      R   R  V     V   I   C      E
//                 SSSS   EEEE   RRRR   V     V   I   C      EEEE
//                     S  E      R  R    V   V    I   C      E
//                S    S  E      R   R    V V     I   C      E
//                 SSSS   EEEEE  R   R     V     III   CCCC  EEEEE
/************************************************************************************************** */
const serviceContent_sparql = 'CONSTRUCT { ?s ?p ?o . }  WHERE { ?s ?p ?o } ';
class ServiceContentClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    cloneOriginal() {return new ServiceContentClass(this._pattern, this._graph); };
};

export const ServiceContentRequest = registerRequest(new ServiceContentClass(serviceContent_sparql, default_graph));

const replaceServiceContentInit_sparql =
    'CLEAR GRAPH <'+default_graph+'>; ' +
    'INSERT DATA { GRAPH <'+default_graph+'> {  } }';
const replaceServiceContent_sparql =
    'CLEAR GRAPH <__SERVICE_GRAPH__>; ' +
    'INSERT DATA { GRAPH <__SERVICE_GRAPH__> { __SERVICE_CONTENT__ } }';

class ReplaceServiceContentClass extends SPARQLText {
    setConfiguration(configuration) {
        // Turtle использует @prefix, а SPARQL UPDATE — PREFIX.
        const prefixes = [];
        const content = configuration.replace(
            /^\s*@(prefix\s+[^\s:]*:|base)\s+(<[^>]+>)\s*\.\s*$/gim,
            (directive, name, iri) => {
                prefixes.push(`${name.toUpperCase()} ${iri}`);
                return '';
            }
        );

        this.setSparql(
            `${prefixes.join('\n')}\n${replaceServiceContent_sparql}`
                .replace(/<__SERVICE_GRAPH__>/g, `<${this._graph}>`)
                .replace('__SERVICE_CONTENT__', content)
                .trim()
        );
    }

    cloneOriginal() { return new ReplaceServiceContentClass(this._pattern,this._graph);}
}

export const ReplaceServiceContentRequest = registerRequest(new ReplaceServiceContentClass(replaceServiceContentInit_sparql,default_graph));

const serviceSubjectForPurlMap_sparql =  'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'  SELECT DISTINCT ?s ?type ?g '+
'  WHERE { VALUES ?g { <http://example.org/graph/1> } '+
'          VALUES ?type { <http://example.org/type/Type1> <http://example.org/type/Type1> } '+
'          VALUES ?subjectPrefix { "http://purl.example.org/resource/" } '+
'          GRAPH ?g { ?s rdf:type ?type . } '+
'          FILTER(isIRI(?s)) '+
'          FILTER(STRSTARTS(STR(?s), ?subjectPrefix)) '+
'} '+
'ORDER BY ?s ?type ?g';

class ServiceSubjectForPurlMapClass extends Request {
    
    constructor(sparql, graph = null){ super(sparql, graph); };
    
    cloneOriginal() {return new ServiceSubjectForPurlMapClass(this._pattern, this._graph); };
    
    set(types, graphs, subjectPrefix){        
        this._request.where[0].values = graphs.map(graph => ({"?g": namedNode(graph)}));
        this._request.where[1].values = types.map(type => ({"?type": namedNode(type)}));
        this._request.where[2].values[0]["?subjectPrefix"].value = subjectPrefix;
    }
}
export const ServiceSubjectForPurlMapRequest = registerRequest(new ServiceSubjectForPurlMapClass(serviceSubjectForPurlMap_sparql,default_graph));

/** Список всех типов в графах */
const serviceTypes_sparql =  'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> '+
'  SELECT DISTINCT ?type '+
'  WHERE { VALUES ?g { <http://example.org/graph/1> } '+
'          GRAPH ?g { ?s rdf:type ?type . } '+
'} '+
'ORDER BY ?type';

class ServiceTypesClass extends Request {
    
    constructor(sparql, graph = null){ super(sparql, graph); };
    
    cloneOriginal() {return new ServiceSubjectForPurlMapClass(this._pattern, this._graph); };
    
    set(graphs){
        this._request.where[0].values = graphs.map(graph => ({"?g": namedNode(graph)}));
    }
}
export const ServiceTypesRequest = registerRequest(new ServiceTypesClass(serviceTypes_sparql,default_graph));


/** Служебный запрос для получения списка проблем в языковых литералах */
const serviceTranslateLangCheck_sparql =`SELECT ?subject ?predicate ?language ?count ?violation
WHERE {
  {
    # Нарушение: более одного значения для одного языка, включая отсутствие языка: ?language = ""
    {
      SELECT ?subject ?predicate ?language (COUNT(*) AS ?count)
      WHERE {
        {
          SELECT ?subject?predicate?value (LANG(?value) AS ?language)
          WHERE {
            ?subject ?predicate ?value .
            FILTER(isLiteral(?value))
          }
        }
      }
      GROUP BY ?subject ?predicate ?language
      HAVING(COUNT(*) > 1)
    }
    BIND(IF(?language = "", "Более одного литерала без языкового тега", CONCAT("Более одного литерала для языка @",?language))AS ?violation)
  }
  UNION
  {
    # Нарушение: для одной пары субъект–предикат одновременно используются значения с языком и без языка
    {
      SELECT ?subject ?predicate (COUNT(*) AS ?count)
      WHERE {
        ?subject ?predicate ?anyValue .
        FILTER(isLiteral(?anyValue))
        FILTER EXISTS {
          ?subject ?predicate ?withoutLanguage .
          FILTER(isLiteral(?withoutLanguage) && LANG(?withoutLanguage) = "")
        }
        FILTER EXISTS {
          ?subject ?predicate ?withLanguage .
          FILTER(isLiteral(?withLanguage) && LANG(?withLanguage) != "")
        }
      }
      GROUP BY ?subject ?predicate
    }
    BIND("*" AS ?language)
    BIND("Одновременно заданы литералы с языковым тегом и без языкового тега" AS ?violation)
  }
}
ORDER BY ?subject ?predicate ?language`;

export const ServiceTranslateLangCheckRequest = registerRequest(new SPARQLText(serviceTranslateLangCheck_sparql, default_graph));

/** Замена URI как субъекта */
const serviceUriReplacementSubject_sparql =
`DELETE { GRAPH <http://localhost/sksa/graph> { <http://old.localhost/sksa/resource> ?p ?o . }}
 INSERT { GRAPH <http://localhost/sksa/graph> { <http://new.localhost/sksa/resource> ?p ?o . }}
 WHERE  { GRAPH <http://localhost/sksa/graph> { <http://old.localhost/sksa/resource> ?p ?o . }}`;

class ServiceUriReplacementSubjectClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setReplacement(oldIri, newIri){
        const update = this._request.updates[0];
        update.delete[0].triples[0].subject.value = oldIri;
        update.insert[0].triples[0].subject.value = newIri;
        update.where[0].patterns[0].triples[0].subject.value = oldIri;
    };
    setGraph(graph){
        const update = this._request.updates[0];
        update.delete[0].name.value = graph;
        update.insert[0].name.value = graph;
        update.where[0].name.value = graph;
        this._graph = graph;
    };
    cloneOriginal() {return new ServiceUriReplacementSubjectClass(this._pattern, this._graph); };
};

export const ServiceUriReplacementSubjectRequest = registerRequest(new ServiceUriReplacementSubjectClass(serviceUriReplacementSubject_sparql, admsAssets_graph));


/** Замена URI как объекта */
const serviceUriReplacementObject_sparql =
`DELETE { GRAPH <http://localhost/sksa/graph> { ?s ?p <http://old.localhost/sksa/resource> . }}
 INSERT { GRAPH <http://localhost/sksa/graph> { ?s ?p <http://new.localhost/sksa/resource> . }}
 WHERE  { GRAPH <http://localhost/sksa/graph> { ?s ?p <http://old.localhost/sksa/resource> . }}`;

class ServiceUriReplacementObjectClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setReplacement(oldIri, newIri){
        const update = this._request.updates[0];
        update.delete[0].triples[0].object.value = oldIri;
        update.insert[0].triples[0].object.value = newIri;
        update.where[0].patterns[0].triples[0].object.value = oldIri;
    };
    setGraph(graph){
        const update = this._request.updates[0];
        update.delete[0].name.value = graph;
        update.insert[0].name.value = graph;
        update.where[0].name.value = graph;
        this._graph = graph;
    };
    cloneOriginal() {return new ServiceUriReplacementObjectClass(this._pattern, this._graph); };
};

export const ServiceUriReplacementObjectRequest = registerRequest(new ServiceUriReplacementObjectClass(serviceUriReplacementObject_sparql, admsAssets_graph));

/** Замена URI как предиката */
const serviceUriReplacementPredicate_sparql =
`DELETE { GRAPH <http://localhost/sksa/graph> { ?s <http://old.localhost/sksa/resource> ?o . }}
 INSERT { GRAPH <http://localhost/sksa/graph> { ?s <http://new.localhost/sksa/resource> ?o . }}
 WHERE  { GRAPH <http://localhost/sksa/graph> { ?s <http://old.localhost/sksa/resource> ?o . }}`;

class ServiceUriReplacementPredicateClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    setReplacement(oldIri, newIri){
        const update = this._request.updates[0];
        update.delete[0].triples[0].predicate.value = oldIri;
        update.insert[0].triples[0].predicate.value = newIri;
        update.where[0].patterns[0].triples[0].predicate.value = oldIri;
    };
    setGraph(graph){
        const update = this._request.updates[0];
        update.delete[0].name.value = graph;
        update.insert[0].name.value = graph;
        update.where[0].name.value = graph;
        this._graph = graph;
    };
    cloneOriginal() {return new ServiceUriReplacementPredicateClass(this._pattern, this._graph); };
};

export const ServiceUriReplacementPredicateRequest = registerRequest(new ServiceUriReplacementPredicateClass(serviceUriReplacementPredicate_sparql, admsAssets_graph));

 //где URI используется
const serviceUriUsedCount_sparql =
`SELECT ?position (COUNT(*) AS ?count)
 WHERE {
    {
        GRAPH <http://localhost/sksa/graph> { <http://localhost/sksa/resource> ?p ?o . }
        BIND("subject" AS ?position)
    }
    UNION {
        GRAPH <http://localhost/sksa/graph> { ?s <http://localhost/sksa/resource> ?o . }
        BIND("predicate" AS ?position)
    }
    UNION {
        GRAPH <http://localhost/sksa/graph> { ?s ?p <http://localhost/sksa/resource> .}
        BIND("object" AS ?position)
    }
}
GROUP BY ?position`;

class ServiceUriUsedCountClass extends Request {
    constructor(sparql, graph = null){ super(sparql, graph); };
    getPositionGraphs(){
        return this._request.where[0].patterns.map(group => group.patterns[0]);
    };
    setIRI(iri){
        const graphs = this.getPositionGraphs();
        graphs[0].patterns[0].triples[0].subject.value = iri;
        graphs[1].patterns[0].triples[0].predicate.value = iri;
        graphs[2].patterns[0].triples[0].object.value = iri;
    };
    setGraph(graph){
        this.getPositionGraphs().forEach(pattern => { pattern.name.value = graph; });
        this._graph = graph;
    };
    cloneOriginal() {return new ServiceUriUsedCountClass(this._pattern, this._graph); };
};

export const ServiceUriUsedCountRequest = registerRequest(new ServiceUriUsedCountClass(serviceUriUsedCount_sparql, admsAssets_graph));

/***************************************************************************************************/
//                   EEEEEE         N     N         OOOO  
//                   E              NN    N         O    O 
//                   E              N N   N         O     O
//                   EEEE           N  N  N         O     O
//                   E              N   N N         O     O
//                   E              N    NN         O    O 
//                   EEEEE          N     N         OOOO 
/***************************************************************************************************/

/** Обновление графов во всех запросах */
export const UpdateGraphIriInAllRequest = (graph) => {
    // console.log("request.js UpdateGraphIriInAllRequest", graph, default_graph, settings.catalog.iri, 
    //     graph == undefined && graph == null && default_graph == graph);
    if (graph == undefined && graph == null && default_graph == graph)
        return;
    default_graph = graph;
    for (let index = 0; index < requests.length; index++) {
        const request = requests[index]; 
        request._graph = graph
    };
};   
